import { fetcher } from '@commenda/utils';

export interface CreateBookkeepingTaskDTO {
  companyId: number;
  corporationId: number;
  effectiveStartDate: string; // ISO 8601 format: YYYY-MM-DD
  effectiveEndDate: string; // ISO 8601 format: YYYY-MM-DD
  dueDate: string; // ISO 8601 format: YYYY-MM-DD
}

export interface CreateBookkeepingTaskResponse {
  id: string;
}

export async function createBookkeepingTask(
  data: CreateBookkeepingTaskDTO
): Promise<{
  success: boolean;
  data?: CreateBookkeepingTaskResponse;
  error?: string;
  status?: number;
}> {
  try {
    const { companyId, corporationId, effectiveStartDate, effectiveEndDate, dueDate } = data;
    const response = await fetcher('service-request', {
      method: 'POST',
      body: {
        companyId,
        corporationId,
        serviceCompositeId: 'AC_BK',
        metadata: { effectiveStartDate, effectiveEndDate, dueDate },
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));

      let errorMessage = 'Failed to create bookkeeping task';
      if (response.status === 400) {
        errorMessage = errorData.message || 'Invalid request';
      } else if (response.status === 404) {
        errorMessage =
          errorData.message ||
          'Corporation not found or Bookkeeping workflow template not found';
      } else if (response.status === 403) {
        errorMessage =
          errorData.message ||
          "You don't have permission to access this corporation";
      }

      return {
        success: false,
        error: errorMessage,
        status: response.status,
      };
    }

    const responseData: CreateBookkeepingTaskResponse = await response.json();

    return {
      success: true,
      data: responseData,
    };
  } catch (error) {
    return {
      success: false,
      error: 'An unexpected error occurred',
    };
  }
}
